import classNames from "classnames";
import { usePWAContext } from "../pwaContextProvider";
import { Localizer } from "infrastructure/localization/localizer";
import { InstallPwaInstructionsModal } from "./installPwaInstructionsModal";
import { showModalMessage } from "core/components/modalMessage/modalMessage";

const pwaInstallInstructionsModalId = "pwa-install-instructions-modal";

type InstallPwaButtonProps = {
  additionalClassNames?: string;
}

const InstallPwa = ({ 
  additionalClassNames 
}: InstallPwaButtonProps) => {
  
  const { 
    deferredPrompt, 
    clearDeferredPrompt, 
    isUsingApp, 
    isIOS 
  } = usePWAContext();

  const onInstallPwaClicked = async () => {
    if(isUsingApp) return;

    if (deferredPrompt) {
      deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === "accepted") {
        console.log("PWA Installed");
      }
      clearDeferredPrompt();
      return;
    }
    
    if (isIOS) {
      showModalMessage(pwaInstallInstructionsModalId);
    }
  };

  const shouldShowButton = !isUsingApp && (deferredPrompt || isIOS);
  if(!shouldShowButton) return <></>;

  return (
    <>
      <div className={classNames(additionalClassNames)} onClick={onInstallPwaClicked}>
        {Localizer.pwa_InstallApp()}
      </div>

      <InstallPwaInstructionsModal 
        modalId={pwaInstallInstructionsModalId} 
      />
    </>
  );
}

export default InstallPwa;
